<adapt-objectives-page-navigator buttonText="Create key results for annual objectives"
                                 [pageActivationTours]="PageActivationTours"></adapt-objectives-page-navigator>
